/**
 * User 그룹 브릿지 목데이터
 */

import type { UserGroup } from './types'

// User group mock responses
export const userMocks: Record<keyof UserGroup, any> = {
  getUid: { uid: 'mock-uid-12345' },
  getGender: { gender: 'man' },
  getBirthYear: { birthYear: 1800 },
  isTester: { isTester: true },
  requestLogin: { success: true }
}
